import { render } from "./IncreaseStock.vue?vue&type=template&id=06e4a3ec"
const script = {}

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__